import { render, staticRenderFns } from "./interest.vue?vue&type=template&id=22deb34a&"
import script from "./interest.vue?vue&type=script&lang=js&"
export * from "./interest.vue?vue&type=script&lang=js&"
import style0 from "./interest.vue?vue&type=style&index=0&id=22deb34a&prod&lang=less&"
import style1 from "./interest.vue?vue&type=style&index=1&id=22deb34a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports